import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { CFCProps, AUTH_TYPE, APP_URL } from 'types';
import { RootState } from 'redux/root.reducer';
import { Loading } from 'carbon-components-react';
import { signInWithTemporaryCode } from 'redux/auth/action';
import { setAppLoginType } from 'redux/app/actions';
import { fetchUserStart } from 'redux/user/actions';
import Service from 'services';
import _ from 'lodash';

export const TemporaryCode: React.FC<Props> = (props: Props) => {
  const { login, session } = props;
  const dispatch = useDispatch();
  const [redirectTo, setRedirectTo] = useState<string>('/');
  const history = useHistory();
  const location = useLocation<{ from?: Location }>();
  const { isSingedInWithTemporaryCode, error } = login;
  const { currentUser: user } = session;

  useEffect(() => {
    const queryString = new URLSearchParams(location.search);
    const rawCode = queryString.get('code') || '';
    const username = queryString.get('username') || '';
    setRedirectTo(queryString.get('redirectTo') || '/');

    if (rawCode && username) {
      const originalCode = atob(rawCode);
      const [code, codeType] = originalCode.split('#');
      const loginType =
        codeType === 'SMARTPHONE_TO_WEB' ? AUTH_TYPE.SMARTPHONE_LOGIN : '';
      dispatch(setAppLoginType(loginType));
      const params = {
        code,
        codeType,
        username
      };
      dispatch(signInWithTemporaryCode(params));
    } else {
      dispatch(setAppLoginType(null));
      Service.auth.ssoLogout();
    }
  }, [location, dispatch, history]);

  useEffect(() => {
    if (isSingedInWithTemporaryCode) {
      if (!_.isEmpty(user)) {
        history.push(redirectTo);
      } else {
        dispatch(fetchUserStart());
      }
    }
  }, [isSingedInWithTemporaryCode, dispatch, user, redirectTo, history]);

  useEffect(() => {
    if (error) {
      history.push(APP_URL.LOGIN);
    }
  }, [error, history]);

  return <>{isSingedInWithTemporaryCode ? <></> : <Loading />}</>;
};

const mapStateToProps = ({ app, login, session }: RootState) => ({
  app,
  login,
  session
});

const connector = connect(mapStateToProps);
type Props = CFCProps<typeof connector>;
TemporaryCode.displayName = 'TemporaryCode';

export default connector(TemporaryCode);
